import { dictionaryApi } from './dictionaryClient';
import { normalizeAnubritti, type Anubritti } from './ashtadhyayiApi';

export type { Anubritti };

export type CreateAnubrittiBody = {
  ashtadhyayiSutraId: number;
  order: number;
  text: string;
  link?: number | null;
  ashtadhyayiPadachhedId?: number | null;
};

export type UpdateAnubrittiBody = Partial<Omit<CreateAnubrittiBody, 'ashtadhyayiSutraId'>>;

function isRecord(x: unknown): x is Record<string, unknown> {
  return x != null && typeof x === 'object' && !Array.isArray(x);
}

function unwrapEntityPayload(raw: unknown): unknown {
  if (isRecord(raw) && 'data' in raw) return raw.data;
  return raw;
}

function normalizeList(data: unknown): Anubritti[] {
  const rows =
    Array.isArray(data) ? data : isRecord(data) && Array.isArray(data.data) ? (data.data as unknown[]) : [];
  return rows
    .map(normalizeAnubritti)
    .filter((x): x is Anubritti => x != null)
    .sort((a, b) => a.order - b.order);
}

export async function listAnubritti(ashtadhyayiSutraId?: number): Promise<Anubritti[]> {
  const params =
    ashtadhyayiSutraId != null && Number.isFinite(ashtadhyayiSutraId)
      ? { ashtadhyayiSutraId }
      : undefined;
  const res = await dictionaryApi.get<unknown>('/ashtadhyayi-anubritti', { params });
  return normalizeList(res.data);
}

export async function getAnubritti(id: number): Promise<Anubritti> {
  const res = await dictionaryApi.get<unknown>(`/ashtadhyayi-anubritti/${id}`);
  const row = normalizeAnubritti(unwrapEntityPayload(res.data));
  if (!row) throw new Error('Invalid anubṛtti response');
  return row;
}

export async function createAnubritti(body: CreateAnubrittiBody): Promise<Anubritti> {
  const res = await dictionaryApi.post<unknown>('/ashtadhyayi-anubritti', body);
  const row = normalizeAnubritti(unwrapEntityPayload(res.data));
  if (!row) throw new Error('Invalid anubṛtti response');
  return row;
}

export async function updateAnubritti(id: number, body: UpdateAnubrittiBody): Promise<Anubritti> {
  const res = await dictionaryApi.patch<unknown>(`/ashtadhyayi-anubritti/${id}`, body);
  const row = normalizeAnubritti(unwrapEntityPayload(res.data));
  if (!row) throw new Error('Invalid anubṛtti response');
  return row;
}

export async function deleteAnubritti(id: number): Promise<void> {
  await dictionaryApi.delete(`/ashtadhyayi-anubritti/${id}`);
}
